// Pure maths of the phone pager: which column a scroll position shows, and
// which one to start on.

/** The column the scroller is closest to. Each column is one scroller width. */
export function indexFromScroll(
    scrollLeft: number,
    width: number,
    count: number
): number {
    if (width <= 0 || count <= 0) return 0;
    const index = Math.round(scrollLeft / width);
    return Math.min(Math.max(index, 0), count - 1);
}

/** The remembered column if it still exists, else the first. */
export function initialIndex(
    ids: readonly string[],
    stored: string | null
): number {
    if (stored === null) return 0;
    const index = ids.indexOf(stored);
    return index === -1 ? 0 : index;
}
